

import React, { useState, useEffect, useRef, useContext  } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import '../../../styles/devotionalContent.css';
import { FaFacebook } from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';
import he from 'he';
import Skeleton from '../../pages/skelton.jsx';
import DevotionalBreadCrumb from '../devotionalBreadCrumb';
import { Helmet } from 'react-helmet-async';
import PageAds from '../../common/pageAds.jsx'
import { DeviceContext } from '../index.jsx';


const DevotionalContent = ({data}) => {

                             const location = useLocation().pathname;
                              const { content } = useParams();
                             const hydratedRef = useRef(false);

                                 // Extract contentId and subCat from URL param
                        const contentId = content?.substring(content.lastIndexOf('-') + 1, content.lastIndexOf('.html'));
                        const cutUrl = content?.substring(0, content.lastIndexOf('-'));
                        const subCat = cutUrl?.substring(cutUrl.lastIndexOf('-') + 1);
                   
                       const [adJson ,setAdJson] = useState(null)
                       const {mobile,setMobile,containerRef} = useContext(DeviceContext)
                          // SSR Data
                            const ssrData = data?.[0]?.contentSinglePage?.contentSinglePageData || null;
                            const  ssrSubBreadCrumb =  ssrData?.breadcums || null 
                            const ssrSingleNews = ssrData?.single_article || null;
                            const ssrPrevNews = ssrData?.prvartcile || null;
                            const ssrNxtNews = ssrData?.nxtarticle || null;
                            const ssrContentId = data?.[0]?.contentSinglePage?.contentId; 
                          
                            // State
                             const [singleNews, setSingleNews] = useState(ssrSingleNews);
                             const [prevNews, setPrevNews] = useState(ssrPrevNews);
                             const [nxtNews, setNxtNews] = useState(ssrNxtNews);
                             const [subBreadCrumb,setSubBreadCrumb] = useState(ssrSubBreadCrumb)
                            const [loading, setLoading] = useState(ssrContentId !== contentId);
                             const [error, setError] = useState(null);
                        
                             
              function isTelugu(text) {
                 const teluguRegex = /[\u0C00-\u0C7F]/;
                 return teluguRegex.test(text);
             }    

                
      useEffect(() => {
        fetch("https://www.teluguone.com/teluguone-ssr-server/ad.php")
         .then(res => res.json())
         .then(data => setAdJson(data))
         .catch(err => console.error(err));
       }, []);                     
                      
                        
    useEffect(() => {
  // Skip fetch only on first SSR hydration
  if (
    !hydratedRef.current &&
    String(ssrContentId) === String(contentId) && ssrData
  ) {
    hydratedRef.current = true;
    setLoading(false);
    setError(null);
    return;
  }

  hydratedRef.current = true;

  let cancelled = false;

  const getTheData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `https://www.teluguone.com/devotional_api/devotionalSingleContentJson?subCat=${subCat}&contentId=${contentId}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      

      const json = await response.json();

      if (cancelled) return;

      setSingleNews(json.single_article || null);
      setPrevNews(json.prvartcile || null);
      setNxtNews(json.nxtarticle || null);
      setSubBreadCrumb(json.breadcums || null)
      setLoading(false);
    } catch (error) {
      if (cancelled) return;

      setError(error.message);
      setSingleNews(null);
      setPrevNews(null);
      setNxtNews(null);
      setLoading(false);
    }
  };

  getTheData();

  return () => {
    cancelled = true;
  };
}, [contentId, subCat]);   


                      

                     if (loading) {
                              return (
                                <div className="devotional-content-page">
                                  <div className="container-fluid">
                                    <div className="row mt-5">
                                      <div className="col-12"><Skeleton type="title" /></div>
                                      <div className="col-4"><Skeleton type="paragraph" /></div>
                                      <div className="col-12 d-flex justify-content-center"><Skeleton type="big-square" /></div>
                                      {[...Array(10)].map((_, i) => (
                                        <div className="col-12 d-flex justify-content-center" key={i}><Skeleton type="paragraph" /></div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              );
                            }




                      if (error) {
                        return (
                          <div className="devotional-content-page">
                            <div className="json-loading-error-div mt-2">
                              <img src="/devotional/assets/images/json_error.png" alt="json_error" />
                            </div>
                          </div>
                        );
                      }
                            

                   
                         


                    return (
                                <div className='devotional-content-page'>
                                 <Helmet><title>{Array.isArray(singleNews) ? singleNews?.[0]?.title : ''} | TeluguOne Devotional</title></Helmet>
                                   <DevotionalBreadCrumb subBreadCrumb={subBreadCrumb} breadCrumb={Array.isArray(singleNews) ? singleNews?.[0]?.title : ''} />
                                  <div className='container-fluid g-0'>
                                      <div className='row g-0'>
                                    

                                     {(singleNews && singleNews.length > 0) && <div className='col-12'>
                                         <div className="devotional-content-main-box">
                                               {/* <p style={{textAlign:"center", margin:"0 0 20px 0"}}>
						                                    <Link href="https://www.teluguone.com/"><img  alt=""  fetchPriority="high" src="https://teluguone.com/teluguoneUserFiles/img/tone.webp" id='tf_year_img'  />
						                                  </Link>
                                               </p> */}
                                            {singleNews?.[0]?.fulldesc && <GetTheFullDescContent  data={singleNews?.[0]?.fulldesc}/>}         
                                            {singleNews?.[0]?.audio_file && <GetTheAudioFullDescContent  data={singleNews?.[0]}/>}         
                                         </div>
                                      </div>}
                      
                                      <div className='col-12 d-flex justify-content-end'>
                                        <Link to={`https://www.facebook.com/sharer.php?u=https://www.teluguone.com/devotional${location}`} className='devotional-content-share-anchor' ><FaFacebook className='devotional-content-share-icon devotional-content-fb-icon' /></Link>
                                        <Link to={`https://twitter.com/share?url=https://www.teluguone.com/devotional${location}`} className='devotional-content-share-anchor'> <FaSquareXTwitter  className='devotional-content-share-icon devotional-content-x-icon' /></Link>
                                      </div>

                                     <div className='col-12 m-3'> 
                                  
                                        <center>      
                                          {adJson && adJson.googleNewsAd?.link ? <a href={adJson?.googleNewsAd?.link} target="_blank" rel="noreferrer">
                                                                                   <img src={adJson?.googleNewsAd?.img} alt="google-ad-img" />
                                                                                   </a>
                                                                                   :
                                                                                   <a href="https://news.google.com/search?q=site:teluguone.com&hl=te&gl=IN&ceid=IN:te" target="_blank" rel="noreferrer">
                                                                                          <img src=" https://www.teluguone.com/images/g-news-banner.gif" alt="google-ad-img" />
                                                                                    </a>
                                                                                   
                                                                                   } 
                                        </center>


                                     </div>

                                   {Array.isArray(prevNews)  ? 
                                                   (
                                <div className='col-6'>
                                  <div className="devotional-content-prev-next-box me-auto">
                                    <Link
                                      key={prevNews?.[0]?.pr_url}
                                      to={prevNews?.[0]?.pr_url?.substring(
                                        prevNews?.[0]?.pr_url.indexOf("/devotional") + 11
                                      )}
                                      style={{ textDecoration: "none" }}
                                    >
                                      <div className="card devotional-content-prev-next-box-card me-auto">
                                        <img
                                          src={
                                            prevNews?.[0]?.pr_image
                                              ? prevNews?.[0]?.pr_image
                                              : "/devotional/assets/images/error_img.webp"
                                          }
                                          alt="prev-img"
                                        />
                                        <div className="devotional-content-card-img-overlay">
                                          <h5 className="card-title devotional-content-prev-next-title devotional-content-prev">
                                            {"← Prev"}
                                          </h5>
                                                                            <p
                                      className="card-text devotional-content-prev-next-heading lh-small me-auto"
                                      style={{
                                        fontFamily: !isTelugu(prevNews?.[0]?.pr_title) && 'sans-serif'
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: prevNews?.[0]?.pr_title
                                          ? he.decode(prevNews?.[0]?.pr_title)
                                          : "prevTitle",
                                      }}
                                    ></p>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                                              ) : <div className='col-6'></div>}

                                 { Array.isArray(nxtNews)  ?
                                  (
                                          <div className='col-6'>
                                            <div className="devotional-content-prev-next-box ms-auto">
                                              <Link
                                                 key={nxtNews?.[0]?.nxt_url}
                                                  to={nxtNews?.[0]?.nxt_url?.substring(
                                                    nxtNews?.[0]?.nxt_url.indexOf("/devotional") + 11
                                                  )}
                                                style={{ textDecoration: "none" }}
                                              >
                                                <div className="card devotional-content-prev-next-box-card">
                                                  <img
                                                    src={
                                                      nxtNews?.[0]?.nxt_image
                                                        ? nxtNews?.[0]?.nxt_image
                                                        : "/devotional/assets/images/error_img.webp"
                                                    }
                                                    alt="next-img"
                                                  />
                                                  <div className="devotional-content-card-img-overlay">
                                                    <h5 className="card-title text-end devotional-content-prev-next-title devotional-content-next ms-auto">
                                                      {"Next →"}
                                                    </h5>
                                                    <p
                                                      className="card-text text-end devotional-content-prev-next-heading lh-small ms-auto"
                                                     

                                                        style={
                                                            !isTelugu(nxtNews?.[0]?.nxt_title || 'Title')
                                                               ? {
                                                                   fontFamily:
                                                                     "'Segoe UI', system-ui, -apple-system, 'Noto Sans Telugu', Roboto, Arial, sans-serif"
                                                                  }
                                                            : {}
                                                        }
                                                      dangerouslySetInnerHTML={{
                                                        __html: nxtNews?.[0]?.nxt_title
                                                          ? he.decode(nxtNews?.[0]?.nxt_title)
                                                          : "Title",
                                                      }}
                                                    ></p>
                                                  </div>
                                                </div>
                                              </Link>
                                            </div>
                                          </div>
                                        ) : <div className='col-6'></div>}

                                <div className='col-12 m-3  photos-vukle-container text-center'>
                                 
                                
                                    </div>

                                      </div>
                                  </div>
                                 <PageAds  mobile={mobile} containerRef={containerRef} />
                              </div>
                    )
                  }

                  export default DevotionalContent;


                  function  GetTheFullDescContent({data}) {
                      
                 const baseURL = "https://www.teluguone.com";
          const finalData = data
                 .replace(/src="\/teluguoneUserFiles/g, `src="${baseURL}/teluguoneUserFiles`)
                     .replace(/src="\/tonecmsuserfiles/g, `src="${baseURL}/tonecmsuserfiles`);

                         function isTelugu(text) {
                 const teluguRegex = /[\u0C00-\u0C7F]/;
                 return teluguRegex.test(text);
             }    

                



                    return (
                      
                          
                          <div className='devotional-content-main-one-description'  style={{
                                        fontFamily: !isTelugu(he.decode(finalData)) && 'sans-serif'
                                      }} dangerouslySetInnerHTML={{ __html: he.decode(finalData) }}></div>
                        

                    )


                }


                  function GetTheAudioFullDescContent(props) {
                  
                  
                    let { data } = props;
                  
                  
                    return (
                      <div
                        className="devotional-content-main-one-description">

                            {data?.title && <p className='text-center'>{data.title}</p>}
                            {data?.audio_file && <audio controls>
                              <source src={data.audio_file} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>}
                           {data?.cont_image && <img fetchpriority='high' src={data.cont_image} alt="audio-img" />}
                        </div>
                    );
                  }